var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 41,
    viewBox: "0 0 51 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_923_14337)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.804,
    height: 27,
    rx: 6.22265,
    transform: "matrix(1 0 -1.01152e-06 1 6.30127 4.55835)",
    fill: "#FFFAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5846 11.5439C35.3271 11.5439 36.0415 11.8276 36.5817 12.337C37.122 12.8463 37.4471 13.5429 37.4907 14.2841L37.4955 14.4549L37.4955 18.7039C37.4954 19.1595 37.335 19.6005 37.0424 19.9498L36.9269 20.0759L32.4431 24.5597C32.1209 24.8819 31.6957 25.0804 31.2418 25.1206L31.0711 25.1283H26.8221C26.0796 25.1284 25.3651 24.8447 24.8249 24.3353C24.2847 23.8259 23.9595 23.1294 23.916 22.3882L23.9111 22.2174L23.9111 14.4549C23.9111 13.7124 24.1948 12.9979 24.7042 12.4577C25.2135 11.9175 25.9101 11.5924 26.6513 11.5488L26.8221 11.5439H34.5846ZM34.5846 12.5143L26.8221 12.5143C26.3325 12.5141 25.8609 12.699 25.5019 13.0319C25.1429 13.3648 24.923 13.8211 24.8863 14.3093L24.8814 14.4549L24.8814 22.2174C24.8813 22.707 25.0662 23.1786 25.3991 23.5376C25.732 23.8965 26.1883 24.1164 26.6765 24.1532L26.8221 24.158H30.7033L30.7033 21.2471C30.7033 20.5046 30.987 19.7901 31.4963 19.2499C32.0057 18.7097 32.7023 18.3846 33.4435 18.341L33.6143 18.3361H36.5252L36.5252 14.4549C36.5254 13.9653 36.3405 13.4937 36.0075 13.1347C35.6746 12.7757 35.2183 12.5558 34.7301 12.5191L34.5846 12.5143ZM36.3146 19.3074L33.6143 19.3065C33.1247 19.3063 32.6531 19.4912 32.2941 19.8241C31.9351 20.157 31.7152 20.6133 31.6785 21.1015L31.6736 21.2471L31.6736 23.9455L31.7571 23.8737L36.2409 19.3899C36.2668 19.364 36.291 19.3365 36.3137 19.3074",
    fill: "#F7CB08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.853 14.6844V21.4899",
    stroke: "#50525E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4502 18.0872H19.2557",
    stroke: "#50525E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_923_14337",
    x: -4.22265,
    y: 0.669192,
    width: 58.8516,
    height: 39.4453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.33349
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.11133
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_923_14337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_923_14337",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNote);
export default __webpack_public_path__ + "static/media/add-note.989e6605f9ed8e420805080c26b227c8.svg";
export { ForwardRef as ReactComponent };